import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';

import actionChoiceCard from './containers/ActionChoiceCard/reducer';
import cachedFormData from './utils/formCaching/reducer';
import call from './containers/Call/reducer';
import checkRegistration from './containers/CheckRegistration/reducer';
import donation from './containers/Donation/reducer';
import electionReminder from './containers/ElectionReminder/reducer';
import email from './containers/Email/reducer';
import findPollingStation from './containers/FindPollingStation/reducer';
import link from './containers/Link/reducer';
import localRep from './containers/LocalRep/reducer';
import multiActionsCard from './containers/MultiActionsCard/reducer';
import petition from './containers/Petition/reducer';
import poll from './containers/Poll/reducer';
import quiz from './containers/Quiz/reducer';
import radialSlider from './containers/RadialSlider/reducer';
import recordVideo from './containers/RecordVideo/reducer';
import repStance from './containers/RepStance/reducer';
import sentimentPoll from './containers/SentimentPoll/reducer';
import tweet from './containers/Tweet/reducer';
import video from './containers/Video/reducer';
import volunteer from './containers/Volunteer/reducer';
import voteRegistration from './containers/VoteRegistration/reducer';
import widget from './containers/Widget/reducer';

export default history =>
    combineReducers({
        actionChoiceCard,
        cachedFormData,
        call,
        checkRegistration,
        donation,
        electionReminder,
        email,
        findPollingStation,
        form: formReducer,
        link,
        localRep,
        multiActionsCard,
        petition,
        poll,
        quiz,
        radialSlider,
        recordVideo,
        repStance,
        router: connectRouter(history),
        sentimentPoll,
        tweet,
        video,
        volunteer,
        voteRegistration,
        widget
    });
